const mutations = {
  setSubDomainConfig(state,subDomainConfig){
    state.subDomainConfig = subDomainConfig
  }
}
export default mutations
